import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  costBreakDownBtn: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  costBreakDownBtnText: {
    fontSize: 14.6,
    marginRight: 4,
  },
  costBreakDownBtnIcon: theme => ({
    tintColor: theme.colors.hyperlinkFive,
  }),
  subHeaderDescriptionMainText: theme => ({
    fontSize: 16,
    color: theme.colors.subtitle,
  }),
  subHeaderContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  stepperViewStyle: {
    marginTop: 20,
  },
  costBreakDownFooter: {
    marginBottom: 11,
    width: '100%',
    right: 16,
  },
});
